export const FETCH_TOPTENS_REQUEST = 'FETCH_TOPTENS_REQUEST';
export const FETCH_TOPTENS_SUCCESS = 'FETCH_TOPTENS_SUCCESS';
export const FETCH_TOPTENS_FAILURE = 'FETCH_TOPTENS_FAILURE';
export const CREATE_TOPTEN_REQUEST = 'CREATE_TOPTEN_REQUEST';
export const CREATE_TOPTEN_SUCCESS = 'CREATE_TOPTEN_SUCCESS';
export const CREATE_TOPTEN_FAILURE = 'CREATE_TOPTEN_FAILURE';
export const CREATE_TOPTENUPDATE_REQUEST = 'CREATE_TOPTENUPDATE_REQUEST';
export const CREATE_TOPTENUPDATE_SUCCESS = 'CREATE_TOPTENUPDATE_REQUEST';
export const CREATE_TOPTENUPDATE_FAILURE = 'CREATE_TOPTENUPDATE_REQUEST';